import { stripClosedThinkTags } from './think-visible.ts';

/** Poslední zprávy do LLM — ne celý chat. */
export const LLM_RECENT_MESSAGES = 8;
/** Dlouhé assistant stěny se v dalším turnu oříznou. */
export const LLM_ASSISTANT_CHARS = 6_000;

export interface LlmHistoryMessage {
  id?: string;
  role: string;
  content: string;
  pending?: boolean;
  compacted?: boolean;
  toolOutput?: { summary: string };
}

export function historyForLlm(
  history: LlmHistoryMessage[],
): { role: string; content: string }[] {
  const usable = history.filter((m) => !m.pending);
  const compact = [...usable].filter((m) => m.compacted).at(-1);
  const recent = usable.slice(-LLM_RECENT_MESSAGES);
  const window = compact && !recent.includes(compact)
    ? [compact, ...recent]
    : recent;

  let fullTools = 1;
  const out: { role: string; content: string }[] = [];
  for (let i = window.length - 1; i >= 0; i--) {
    const m = window[i];
    if (!m) continue;
    let content: string;
    if (m.toolOutput && fullTools <= 0) {
      content = m.toolOutput.summary;
    } else {
      content = m.content;
      if (m.toolOutput) fullTools--;
    }
    content = stripClosedThinkTags(content || '');
    if (m.role === 'assistant' && content.length > LLM_ASSISTANT_CHARS) {
      content = `${content.slice(0, LLM_ASSISTANT_CHARS)}\n…`;
    }
    if (!content) continue;
    out.unshift({ role: m.role, content });
  }
  return out;
}
